<template>
  <p class="my-5 font-medium">
    <slot />
  </p>
</template>
